import server from '../../api/server';

export class MouldingConsultService {
    static async mouldingConsult(token: string, userId: number, consultId: number): Promise<any> {
        const headers = {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
        };

        try {
            const responseServer = await server.post(
              `staff/nutrition-consult/moulding/${userId}/${consultId}`,
              "",
              {headers}
            );

            if (responseServer.data.statusCode != 200) {
                console.log("ERROR");
            }

            return responseServer.data.data;
        } catch (error: any) {
            throw new Error(error.response.status);
        }
    }
}
